export type AppEnvironment = 'development' | 'production';

export default function getEnvironment(): AppEnvironment {
  if (typeof window === 'undefined') {
    return import.meta.env.MODE === 'production' ? 'production' : 'development';
  }

  if (window.location.hostname === 'cp.nrggroup.nl') {
    return 'production';
  }

  return 'development';
}
